// 从路由对象中获取活动ID
export function getActivityIdFromRoute(route) {
  if (route && route.query && route.query.activityId) {
    return route.query.activityId;
  }
  return null;
}

// 从当前URL中获取活动ID
export function getActivityId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('activityId') || null;
}
